import { IReceiverPart } from '../models/product-detail';

export const getExistingReceivers = (
    receivers: IReceiverPart[] | null,
    isMiracleEar: boolean,
    orderType: string
) => {
    const filteredReceivers = receivers;
    if (filteredReceivers && filteredReceivers.some((r) => r.partType === 2)) {
        filteredReceivers.map((r) => {
            r.gain = r.gainAsLetter;
        });
    }
    if (isMiracleEar && orderType === 'patient') {
        return filteredReceivers
            ? filteredReceivers.filter((r) => r.isAdditionalReceiver)
            : null;
    }
    return receivers;
};
